// extracted by mini-css-extract-plugin
export default {"header":"App_header__PKNxv","sidebar":"App_sidebar__Ppt1G"};